export default {
  nav: {
    main: '主页',
    ordersAndInvoices: '订单和发票',
    drafts: '草稿',
    automation: '自动化',
    workspace: '工作区',
    templates: '模板',
    delivery: '交付',
    settings: '设置',
    shippingLabels: '运单标签',
    subscriptions: '订阅',
    support: '支持',
    developer: '开发者',
    writeReview: '撰写评论',
    supportTicket: '支持工单',
    welcomeTour: '欢迎导览',
    administratorConsole: '管理员控制台',
    logout: '退出登录',
  },
  dashboard: {
    pageTitle: '订单和发票',
    pageDescription: 'Manage your orders and invoices',
    title: '订单和发票',
    selectedOrders: '已选择 {count} 个订单',
    completed: '% 已完成',
    processing: '正在处理，请稍候...',
    bulkDownload: '批量下载',
    upgradeBulkDownload: '升级您的计划以使用批量下载',
    showFilters: '显示筛选条件',
    hideFilters: '隐藏筛选条件',
    creatingInvoices: '正在创建发票，请稍候...',
    bulkCreateInvoices: '批量创建发票',
    cannotCreateAutopilot: '当开票模式为自动时，您无法手动创建发票。',
    exportInvoices: '导出发票或订单',
    capturePayments: '手动收款',
    filterOrders: '筛选订单',
    error: '出错了...',
    close: '关闭',
    chooseDate: '选择日期',
    chooseIssueDate: '为所选发票选择开具日期',
    cancel: '取消',
    createInvoices: '创建发票',
    storno: '冲销',
    bulkOrderCapture: '批量订单收款',
  },
  search: {
    createdBetween: '创建于',
    modifiedBetween: '修改于',
    orderNumber: '订单 #',
    invoiceNumber: '发票 #',
    refundNumber: '退款 #',
    customer: '客户',
    payment: '付款',
    any: '全部',
    authorized: '已授权',
    pending: '待处理',
    paid: '已支付',
    partiallyPaid: '部分支付',
    refunded: '已退款',
    voided: '已作废',
    partiallyRefunded: '部分退款',
    unpaid: '未支付',
    fulfillment: '履行',
    fulfilled: '已发货',
    partial: '部分发货',
    unfulfilled: '未发货',
    loading: '正在加载订单...',
    search: '搜索',
  },
  orderList: {
    noCustomer: '无客户',
    downloadOrder: '下载订单',
    deleteWarning: '重要！这将删除该日期之后创建的所有发票和退款：',
    includingInvoice: '包括所选发票 #',
    pressOk: '按确定继续，或按取消中止。',
    cannotCreateAutopilot: '当开票模式为自动时，您无法手动创建发票。',
    createInvoice: '为此订单创建发票',
    create: '创建',
    addCreditNote: '添加贷项通知单',
    createStorno: '创建冲销发票',
    refund: '退款',
    downloadInvoice: '下载此发票',
    download: '下载',
    default: '默认',
    downloadStorno: '下载此冲销/贷项通知单',
    fulfillOrder: '履行订单',
    orderNum: '订单 #',
    locPrefix: '位置前缀',
    invoiceNum: '发票 #',
    refundNum: '退款 #',
    customerCol: '客户',
    orderCreatedDate: '订单创建日期',
    orderModifiedDate: '订单修改日期',
    delivered: '已送达',
    paymentStatus: '付款状态',
    fulfillmentStatus: '发货状态',
    totalOutstanding: '未结总额',
    originalPrice: '原价',
    noOrders: '您的商店在所选状态下没有订单。',
    cannotCreateNoOrders: '没有订单时无法创建发票。',
    createOrdersFirst: '请先创建至少一个订单，然后重试。',
    createOrders: '创建订单',
    loadingOrders: '加载中...',
    paidManual: '已支付 - 手动',
    paid: '已支付',
    refunded: '已退款',
    pending: '待处理',
    partiallyPaid: '部分支付',
    partiallyRefunded: '部分退款',
    fulfilled: '已发货',
    unfulfilled: '未发货',
    deliveryPending: '待处理',
    deliverNow: '立即配送',
    deliveryPartial: '部分配送',
    notDelivered: '未配送',
    deliverAgain: '再次配送',
    deliveryDetails: '配送详情',
    deliveryFailed: '配送失败',
    sent: '已发送',
    failed: '失败',
    toLabel: '收件人',
    folderLabel: '文件夹',
    open: '打开',
    invoice: '发票',
    creditNote: '贷记单',
    stornoLabel: '冲销',
    unknown: '未知',
    googleDrive: 'Google Drive',
    clientsTablet: '客户平板',
    shippyPro: 'ShippyPro',
    emailChannel: '电子邮件',
    ftpChannel: 'FTP',
    revertToDate: '恢复到此日期',
    add: '添加',
    close: '关闭',
  },
  downloadDialog: {
    downloadType: '下载 {type}...',
    selectTemplate: '从模板库中选择一个模板来导出订单、发票、冲销发票或贷项通知单。',
    getMoreTemplates: '获取更多模板',
    createNewTemplate: '创建新模板',
    allCreatedBetween: '所有在此期间创建的 {type}',
    selectedType: '已选择的 {type}',
    and: '和',
    status: '状态',
    any: '全部',
    open: '未结',
    closed: '已关闭',
    cancelled: '已取消',
    paymentStatus: '付款状态',
    fulfillmentStatus: '发货状态',
    fulfilled: '已发货',
    partial: '部分发货',
    unfulfilled: '未发货',
    authorized: '已授权',
    pending: '待处理',
    paid: '已支付',
    partiallyPaid: '部分支付',
    refunded: '已退款',
    voided: '已作废',
    partiallyRefunded: '部分退款',
    unpaid: '未支付',
    format: '格式',
    forLocation: '按位置',
    advancedOptions: '高级选项',
    exportHSCodes: '导出库存HS编码（较慢）',
    noteChrome: '注意：为获得最佳下载效果，建议使用Chrome浏览器并禁用广告拦截器。',
    downloadIndividually: '单独下载',
    downloadGrouped: '合并下载',
  },
  templates: {
    pageTitle: '模板',
    pageDescription: 'Customize your invoice templates',
    title: '模板',
    installTranslated: '安装翻译模板',
    installTranslatedDesc: '点击此按钮选择其他语言。',
    createNew: '如有需要，创建新模板',
    createNewDesc: '如有需要，点击此按钮创建新模板。',
    customize: '自定义模板',
    customizeDesc: '点击默认模板进行自定义。您可以更改徽标、颜色，高级用户还可以修改背后的代码。',
    defaultTemplate: '发票、冲销和贷项通知单（默认）',
    logo: '徽标',
    colorPalette: '调色板',
    getColorPalettes: '获取调色板',
    paperSize: '纸张大小',
    format: '格式',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: '方向',
    landscape: '横向',
    portrait: '纵向',
    margin: '边距（厘米）',
    unsavedChanges: '未保存的更改',
    discard: '放弃',
    save: '保存',
  },
  labels: {
    pageTitle: '运单标签',
    pageDescription: 'Create and manage shipping labels',
    title: '运单标签',
    glsRequiresPro: 'GLS 东欧运单标签需要专业版计划。',
    upgradeDesc: '升级到专业版以创建和管理运单标签。',
    upgradePlan: '升级您的计划',
    eeuGls: 'EEU GLS',
    enabled: '已启用',
    country: '国家',
    hungary: '匈牙利',
    slovakia: '斯洛伐克',
    czech: '捷克',
    romania: '罗马尼亚',
    slovenia: '斯洛文尼亚',
    croatia: '克罗地亚',
    senderId: '发件人 ID',
    username: '用户名',
    password: '密码',
    name: '姓名',
    city: '城市',
    address: '地址',
    zipCode: '邮政编码',
    contactPerson: '联系人',
    phone: '电话',
    email: '电子邮件',
    glsServices: 'GLS 服务',
    expressService: '快递服务',
    exchangeService: '换货服务',
    smsService: '短信服务',
    smsText: '短信内容',
    preAdviceService: '预通知服务',
    unsavedChanges: '未保存的更改',
    discard: '放弃',
    save: '保存',
  },
  billing: {
    pageTitle: '账单',
    pageDescription: 'Manage your subscription and billing',
    title: '账单',
    subscriptionFor: '商店的订阅计划',
    currentlySubscribed: '您当前订阅的是',
    plan: '计划',
    cancelSubscription: '取消订阅',
    upgradePlan: '升级您的计划',
    professional: '专业版',
    proPriceMonthly: '$29.99 / 月',
    upgrade: '升级',
    includesAllStarter: '包含所有入门版功能，另有：',
    proFeature1: '全球合规套件：基于位置的前缀和自定义顺序编号',
    proFeature2: '智能本地化：自动翻译的电子邮件和本地化的 PDF 附件',
    proFeature3: '完整的 B2B 文档生命周期：形式发票、B2B 报价和贷项通知单',
    proFeature4: 'B2B 会计同步：3 位小数精度和多币种显示',
    proFeature5: '自动备份：自动将发票复制到安全的 FTP 或 Google Drive',
    proFeature6: 'Shopify Flow：通过 Flow 触发器和操作自动化发票生成、交付和冲销',
    proFeature7: '高级 AI 逻辑：使用设备端 AI 实现复杂的条件布局规则',
    proFeature8: 'UBL XML 和 ZUGFeRD / Factur-X 导出（欧洲电子发票合规）',
    proFeature9: 'EPC QR 码用于即时移动 POS 支付',
    proFeature10: 'GLS 东欧运单标签',
    proFeature11: '7 年合规税务保留',
    currentlyUsing: '您当前使用的是我们的',
    free: '免费',
    subscriptionPlan: '订阅计划。',
    monthlyUsage: '每月用量',
    monthlyGenerated: '本月 {count} / 50 张发票',
    monthlyLimitReached: '已达每月上限。升级到入门版以获取无限发票。',
    freePlan: '免费版',
    freeToInstall: '免费安装',
    freeFeature1: '每月最多 50 张发票/订单',
    freeFeature2: '访问所有 31+ 个预定义模板',
    freeFeature3: '基础 AI 助手',
    freeFeature4: '标准 PDF 下载和打印',
    freeFeature5: '标准文档套件（发票、装箱单、收据）',
    freeFeature6: '3 个月安全发票保留',
    starterPlan: '入门版',
    starterPrice: '$9.99 / 月',
    starterPricePerInvoice: '+ 每张发票 3 美分',
    subscribe: '订阅',
    starterFeature1: '无限发票和订单',
    starterFeature2: '通过电子邮件自动交付 PDF',
    starterFeature3: '完全访问混合编辑器和 AI 助手',
    starterFeature4: 'Shopify POS 和条码集成',
    starterFeature5: 'Shopify Flow：发票自动化的触发器和操作',
    starterFeature6: 'UBL XML / PEPPOL 和 ZUGFeRD / Factur-X 导出（电子发票合规）',
    starterFeature7: '1 年安全发票保留',
    proTaxOverrides: '自定义税率覆盖：按产品的增值税/商品服务税和 SKU 级别税率',
    unsavedChanges: '未保存的更改',
    discard: '放弃',
    save: '保存',
  },
  autopilot: {
    pageTitle: '自动化',
    pageDescription: 'Automate invoice creation and management',
    title: '自动化',
    autoCreate: '自动创建发票',
    disabled: '禁用（手动）',
    whenCreated: '当订单创建时',
    whenFulfilled: '当订单履行时',
    whenPaid: '当订单付款时',
    autoCreateDesc: '发票将在订单创建、履行或付款的日期自动创建。',
    autoStorno: '自动冲销发票',
    whenCancelled: '当订单取消或退款时',
    autoStornoDesc: '冲销发票将在订单作废/取消或创建退款的日期自动创建。',
    cannotAutoFree: '免费计划无法自动创建发票。',
    upgradePlan: '升级您的计划',
    unsavedChanges: '未保存的更改',
    discard: '放弃',
    save: '保存',
  },
  delivery: {
    pageTitle: '交付',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: '交付',
    settings: '设置',
    useOrderNumbers: '使用订单号作为文件名',
    sendIfCountry: '当账单地址国家为以下时发送',
    countryCodesHint: '所有国家代码用分号分隔。',
    sendForTags: '为具有以下标签之一的客户发送',
    tagsHint: '所有标签用分号分隔。',
    emailDelivery: '电子邮件交付',
    sendAsPdf: '将发票作为 PDF 附件发送给客户',
    autoSend: '创建发票时自动发送',
    subject: '主题',
    body: '正文',
    xmlAttachments: 'XML 附件',
    attachUbl: '附加 UBL/PEPPOL XML (E-Factura)',
    attachZugferd: '附加 ZUGFeRD / Factur-X XML',
    sendTestEmail: '发送测试邮件',
    sending: '正在发送...',
    customSmtp: '自定义 SMTP 服务器',
    customSmtpDesc: '使用您自己的邮件服务器代替默认服务器',
    enableSmtp: '启用自定义 SMTP',
    smtpHost: 'SMTP 主机',
    port: '端口',
    useSsl: '使用 SSL/TLS',
    username: '用户名',
    password: '密码',
    fromEmail: '发件人邮箱',
    fromName: '发件人名称',
    shopifyLiquid: 'Shopify Liquid 模板',
    pasteInto: '将此粘贴到您的',
    orderConfirmation: '订单确认模板',
    toAddLink: '以添加下载链接。',
    downloadInvoice: '下载您的发票',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: '创建发票时向 ClientsTablet 发送请求',
    shippyPro: 'ShippyPro',
    shippyProDesc: '将 PDF 发票作为海关文件发送到 ShippyPro（适用于非欧盟国家）',
    ftpBackup: 'FTP / SFTP 备份',
    ftpDesc: '自动将发票复制到您的服务器',
    enableFtp: '启用自动 FTP 备份',
    host: '主机',
    useSftp: '使用 SFTP（安全）',
    destinationFolder: '目标文件夹',
    xmlFiles: 'XML 文件',
    includeUbl: '包含 UBL/PEPPOL XML (E-Factura)',
    includeZugferd: '包含 ZUGFeRD / Factur-X XML',
    testConnection: '测试连接',
    testing: '正在测试...',
    pro: 'PRO',
    upgradeFtp: '升级到专业版以自动将发票复制到您的 FTP/SFTP 服务器。',
    googleDrive: 'Google Drive',
    googleDriveDesc: '自动将发票同步到您的 Drive',
    connected: '已连接',
    disconnect: '断开连接',
    notWorking: '无法使用？请前往',
    googlePermissions: 'Google 权限',
    removeThenReconnect: '移除 Invoice Browse，然后重新连接。',
    connectGoogleDrive: '连接 Google Drive',
    upgradeGoogleDrive: '升级到专业版以自动将发票同步到 Google Drive。',
    unsavedChanges: '未保存的更改',
    discard: '放弃',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: '保存',
  },
  bookkeeping: {
    pageTitle: '设置',
    pageDescription: 'Configure your invoice settings',
    title: '设置',
    owner: '所有者',
    email: '电子邮件',
    phone: '电话',
    keepDifferentNumbering: '为每个订单位置保留不同的发票编号',
    keepDifferentNumberingDisabled: '您的计划不支持为每个订单位置保留不同的发票编号。',
    locationEmailDesc: '这允许您根据订单位置（库存位置、收货地址或账单地址）发送翻译后的电子邮件和发票',
    upgradePlan: '升级您的计划',
    matchingCriteria: '匹配条件',
    locationId: '位置 ID',
    shippingCountryCode: '收货地址国家代码',
    billingCountryCode: '账单地址国家代码',
    matchLocationDesc: '根据订单位置 ID、收货地址或账单地址国家代码匹配位置。',
    companyInfo: '公司信息',
    name: '名称',
    website: '网站',
    registrationNumber: '注册号',
    taxId: '税号',
    addressSection: '地址',
    streetName: '街道名称',
    streetNumber: '街道号码',
    zip: '邮编',
    city: '城市',
    region: '地区',
    country: '国家',
    bankingInfo: '银行信息',
    bankName: '银行名称',
    swift: 'Swift',
    currency: '货币',
    iban: 'IBAN',
    invoicing: '开票',
    decimalPlaces: '小数位数',
    invoicesPrefix: '发票前缀',
    currentInvoiceNumber: '当前发票编号',
    creditNotesPrefix: '贷项通知单前缀',
    currentCreditNoteNumber: '当前贷项通知单编号',
    lastInvoiceDate: '最后发票日期',
    noInvoicesYet: '尚未创建发票。',
    confirmReverting: '确认回退系统',
    allInvoicesAfter: '在此日期之后开具的所有发票及其冲销',
    willBeRemoved: '将被删除。继续回退系统？',
    cancel: '取消',
    revert: '回退',
    revertDesc: '回退系统将删除所选日期之后创建的所有发票。',
    revertToDate: '回退到此日期',
    reverting: '正在回退系统，请稍候...',
    useOrderNumbering: '使用订单编号',
    showVat: '在发票上显示增值税',
    overrideTaxes: '覆盖税率',
    pricesIncludeTax: '价格含税',
    productsTaxRate: '产品税率',
    shippingTaxRate: '运费税率',
    skusSeparated: 'SKU 用分号分隔',
    skusTaxRate: 'SKU 税率',
    useOrderDates: '使用订单创建日期作为发票日期',
    convertCurrency: '将价格转换为客户支付的货币',
    unsavedChanges: '未保存的更改',
    discard: '放弃',
    save: '保存',
  },
  drafts: {
    pageTitle: '草稿',
    pageDescription: 'Manage your draft orders',
    title: '草稿',
    download: '下载',
    newDraft: '新建草稿',
    exporting: '正在导出 {status}%...',
    accessNotGranted: '草稿订单访问权限未授予。请',
    reLogin: '重新登录',
    toGrantPermissions: '以授予所需的"草稿订单"权限。',
    pushFailed: '推送到 Shopify 失败：',
    exportError: '导出错误：',
    confirmDelete: '您确定要删除此草稿吗？',
    incompleteCustomer: '客户数据不完整：',
    pushWithoutCustomer: '草稿将在没有客户数据的情况下推送到 Shopify。继续？',
    customerNotInShopify: '此客户在 Shopify 中尚不存在。',
    warnings: '警告：',
    createCustomerAndPush: '在 Shopify 中创建客户并推送草稿订单？',
    downloadTitle: '下载草稿',
    cancel: '取消',
  },
  draftEdit: {
    number: "编号",
    prefix: "前缀",

    newDraft: '新建草稿',
    editDraft: '编辑草稿',
    viewInShopify: '在 Shopify 中查看',
    back: '返回',
    createDraft: '创建草稿',
    saveChanges: '保存更改',
    documentType: '文档类型',
    draftOrder: '草稿订单',
    quote: '报价单',
    proforma: '形式发票',
    manualInvoice: '手动发票',
    currency: '货币',
    expiryDate: '到期日期',
    status: '状态',
    draft: '草稿',
    sent: '已发送',
    accepted: '已接受',
    customer: '客户',
    firstName: '名',
    lastName: '姓',
    email: '电子邮件',
    phone: '电话',
    company: '公司',
    taxId: '税号',
    billingAddress: '账单地址',
    address: '地址',
    aptSuite: '公寓/套房',
    city: '城市',
    province: '省份',
    countryField: '国家',
    zip: '邮编',
    shippingAddress: '收货地址',
    sameAsBilling: '与账单地址相同',
    lineItems: '行项目',
    shipping: '运费',
    shippingTitle: '标题',
    shippingPlaceholder: '例如 标准快递',
    price: '价格',
    note: '备注',
    notePlaceholder: '内部备注或给客户的留言...',
    summary: '摘要',
    subtotal: '小计',
    discounts: '折扣',
    tax: '税费',
    total: '合计',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: '输入您的商店地址',
    loginWith: '登录方式',
    createAccount: '创建新账户',
    placeholder: 'your-shop-name',
    shopRequired: '商店名称为必填项',
    login: '登录',
    shopify: 'Shopify',
    terms: '条款和条件',
    privacy: '隐私政策',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: '喜欢 Invoice Browse 吗？',
    description: '您已经创建了第一批发票！如果您觉得这个应用有用，在 Shopify 应用商店留下简短评论对我们帮助很大。',
    reward: '为表感谢，我们将把您的每月使用计数器重置为 0',
    leaveReview: '留下评论',
    maybeLater: '以后再说',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: '欢迎使用 Invoice Browse',
    welcomeContent: '让我向您展示如何使用它。',
    dashboardTitle: '仪表板',
    dashboardContent: '您看到的屏幕是主仪表板。在这里您可以找到所有订单，并可以将它们导出为不同的文档类型，如：发票、装箱单等。',
    automationTitle: '让您的生活更轻松',
    automationContent: '启用自动化，在订单付款或退款时自动创建发票。',
    templatesTitle: '自定义模板',
    templatesContent: '进入此处翻译您的模板、自定义它或创建新模板。',
    deliveryTitle: '交付',
    deliveryContent: '配置我们的应用，将创建的文档自动复制到 FTP、Google Drive 或作为电子邮件附件发送。',
    settingsTitle: '设置',
    settingsContent1: '调整文档中使用的公司电话、电子邮件和其他字段。',
    settingsContent2: '更改文档起始编号或删除在某个日期之后创建的文档。',
    settingsContent3: '覆盖运费和产品的增值税税率',
    settingsContent4: '更改数字的小数位数',
    reviewTitle: '撰写评论',
    reviewContent: '通过给我们写一篇好评来支持我们的团队！',
    tourTitle: '欢迎导览',
    tourContent: '您可以从这里再次打开此导览。',
    createDocTitle: '创建您的第一个文档',
    createDocContent: '点击"创建"按钮来创建您的第一个文档。',
    docNumberTitle: '文档编号',
    docNumberContent: '第一个文档分配的编号为 1。如果您想从其他编号开始，可以在设置中更改。',
    downloadDocTitle: '下载文档',
    downloadDocContent: '点击下载下拉菜单并选择一个文档模板，将您的订单导出为 PDF。',
  },
  common: {
    save: '保存',
    cancel: '取消',
    close: '关闭',
    discard: '放弃',
    delete: '删除',
    edit: '编辑',
    create: '创建',
    loading: '加载中...',
    unsavedChanges: '未保存的更改',
    upgradePlan: '升级您的计划',
  },
  languageSelector: {
    label: '语言',
    auto: '自动检测',
  },
  draftList: {
    draftNum: '草稿 #',
    shopifyId: 'Shopify ID',
    type: '类型',
    customer: '客户',
    total: '合计',
    status: '状态',
    delivered: '已交付',
    date: '日期',
    actions: '操作',
    noCustomer: '无客户',
    noDrafts: '未找到草稿或报价。',
    loading: '加载中...',
    download: '下载',
    default: '默认',
    pending: '待处理',
    deliverNow: '立即交付',
    deliveryDetails: '交付详情',
    sent: '已发送',
    failed: '失败',
    deliverAgain: '重新交付',
    partial: '部分',
    notDelivered: '未交付',
    deliveryFailed: '交付失败',
    unknown: '未知',
    edit: '编辑',
    send: '发送',
    pushToShopify: '推送到Shopify',
    complete: '完成',
    duplicate: '复制',
    delete: '删除',
    quote: '报价',
    proforma: '形式发票',
    draftOrder: '草稿订单',
    manualInvoice: '手动发票',
  },
  draftSearch: {
    createdBtw: '创建于',
    draftNum: 'Draft #',
    shopifyId: 'Shopify ID',
    customer: '客户',
    status: '状态',
    type: '类型',
    delivery: '交付',
    any: '全部',
    draft: '草稿',
    sent: '已发送',
    accepted: '已接受',
    expired: '已过期',
    converted: '已转换',
    cancelled: '已取消',
    quote: '报价',
    proforma: '形式发票',
    draftOrder: '草稿订单',
    manualInvoice: '手动发票',
    delivered: '已交付',
    notDelivered: '未交付',
    pending: '待处理',
    search: '搜索',
  },
  draftDownload: {
    title: '下载 草稿 #...',
    selectTemplate: 'Select a template from the gallery to export drafts, quotes, or proformas.',
    allDraftsBetween: 'All drafts between',
    selectedDrafts: 'Selected drafts',
    and: 'and',
    status: '状态',
    documentType: '类型',
    any: '全部',
    draft: '草稿',
    sent: '已发送',
    accepted: '已接受',
    expired: '已过期',
    converted: '已转换',
    cancelled: '已取消',
    quote: '报价',
    proforma: '形式发票',
    draftOrder: '草稿订单',
    manualInvoice: '手动发票',
    format: 'Format',
    noTemplates: 'No templates found',
    noTemplatesForType: 'No templates found for document type "{type}".',
    installTemplates: 'Install templates',
    toStartExporting: 'to start exporting.',
    noteChrome: 'Note: For optimal download Chrome browser is recommended and any Adblocker to be disabled.',
    cancel: 'Cancel',
    downloadIndividually: 'Download Individually',
    downloadGrouped: 'Download Grouped',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: '安装新模板',
    tabStyle: '样式',
    tabContent: '内容',
    tabTranslations: '翻译',
    tabSettings: '设置',
    tabCode: '代码',
    tabCopilot: 'AI助手',
    logo: '标志',
    colorPalette: '调色板',
    colorText: 'Text',
    colorBg: 'BG',
    colorBorder: 'Border',
    colorPrimary: 'Primary',
    colorAccent: 'Accent',
    font: 'Font',
    fontDefault: 'Default (DM Sans)',
    fontSize: 'Font Size',
    fontSizeDefault: 'Default (11.5px)',
    fontSizeCompact: 'Compact',
    fontSizeSmall: 'Small',
    fontSizeMediumSmall: 'Medium Small',
    fontSizeMedium: 'Medium',
    fontSizeMediumLarge: 'Medium Large',
    fontSizeLarge: 'Large',
    fontSizeExtraLarge: 'Extra Large',
    documentTitle: 'Document Title',
    documentTitlePlaceholder: 'e.g. Invoice, Tax Invoice, Factura...',
    noToggleSupport: 'This template does not support toggle controls. Switch to a gallery template for full customization.',
    sections: 'Sections',
    shippingAddress: 'Shipping address',
    bankPaymentDetails: 'Bank / payment details',
    paymentStatusBadge: 'Payment status badge',
    orderNotes: 'Order notes',
    trackingFulfillment: 'Tracking / fulfillment info',
    termsConditions: 'Terms & conditions',
    signatureLines: 'Signature lines',
    qrCode: 'QR code',
    lineItems: 'Line Items',
    taxColumns: 'Tax columns (VAT / GST)',
    productSku: 'Product SKU',
    productImages: 'Product images',
    discountBreakdown: 'Discount breakdown',
    itemWeight: 'Item weight',
    hsCode: 'HS code (customs)',
    mergeDiscounts: 'Merge discounts into product price',
    showOrderDiscountAsSummary: 'Show order discount as a summary line',
    totals: 'Totals',
    subtotalBeforeTax: 'Subtotal (before tax)',
    taxBreakdownByRate: 'Tax breakdown by rate',
    shippingCostSeparate: 'Shipping cost as separate line',
    dueDate: 'Due date',
    formatting: 'Formatting',
    dateFormat: 'Date format',
    decimalPlaces: 'Decimal places',
    paymentTerms: 'Payment terms',
    paymentTermsNone: 'None',
    thankYouMessage: 'Thank you message',
    thankYouPlaceholder: 'Thank you for your business!',
    countryMatchTitle: 'Use this template when shipping or billing address matches this country',
    addressType: 'Address Type',
    addressDisabled: 'Disabled',
    addressShipping: 'Shipping Address',
    addressBilling: 'Billing Address',
    country: 'Country',
    anyCountry: 'Any country',
    countryMatchDesc: 'When enabled, this template will be used automatically for orders where the selected address matches the chosen country.',
    languagePreset: 'Language Preset',
    selectLanguage: 'Select a language...',
    languagePresetDesc: 'Selecting a language fills in all labels below. You can then customize individual fields.',
    paperSize: 'Paper Size',
    format: 'Format',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Landscape',
    margin: 'Margin (cm)',
    template: 'Template',
    templateName: 'Name',
    systemAlias: 'System Alias',
    systemAliasDesc: 'for POS/Admin URL routes',
    systemAliasNone: 'None',
    defaultTemplate: 'Default template',
    defaultTemplateDesc: 'Used for direct links shared with customers.',
    posRouteDesc: 'Maps to /template/[alias]/receipt.pdf for POS integration.',
    documentType: 'Document Type',
    invoiceCreditNote: 'Invoice + Credit Note',
    order: 'Order',
    invoiceOnly: 'Invoice only',
    quoteEstimate: 'Quote / Estimate',
    proformaInvoice: 'Proforma Invoice',
    refund: 'Refund',
    stornoInvoice: 'Storno Invoice',
    creditNoteOnly: 'Credit Note only',
    reportLiquid: 'Report (Liquid only)',
    hideRemovedItems: 'Hide removed/refunded line items',
    location: 'Location',
    locationEmpty: 'Leave empty to use for all locations',
    dangerZone: 'Danger Zone',
    dangerZoneDesc: 'Permanently remove this template from your account.',
    removeTemplate: 'Remove template',
    bodyTemplate: 'Body Template',
    bodyTemplateDesc: 'Uses Mustache or Liquid syntax. Click a snippet:',
    rowTemplate: 'Row Template',
    rowTemplateDesc: 'Rendered once per line item. Click a snippet:',
    variableReference: 'Variable Reference',
    formatCode: 'Format Code',
    insert: 'Insert',
    copy: 'Copy',
    loadModelContinue: 'Load Model & Continue',
    cancel: 'Cancel',
    copilotPlaceholder: 'Try: translate to Romanian, show tax columns, add barcode, use teal palette...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Undo',
    redo: 'Redo',
    aiThinking: 'AI is thinking...',
    proposedChanges: 'Proposed Changes',
    applyChanges: 'Apply Changes',
    dismiss: 'Dismiss',
    aiEngineReady: 'AI Engine ready',
    loadingAiModel: 'Loading AI model...',
    aiEngineOff: 'AI Engine off —',
    loadForAdvanced: 'load for advanced edits',
    instantCommands: 'translate, show/hide sections, add snippets, change font/colors/paper',
    aiEngineDesc: 'structural HTML edits, layout changes, custom modifications',
    aiLocalDesc: 'Model runs locally via WebGPU — no data leaves your browser. Larger models are more accurate but use more VRAM.',
    aiUpgradeDesc: 'upgrade to Starter or Professional to unlock advanced AI template editing.',
    upgrade: 'Upgrade',
    loadAiQuestion: 'Load AI Engine?',
    loadAiDesc: 'The on-device AI model will download and run locally using WebGPU. This requires ~1-3 GB of free VRAM/RAM and a modern GPU (M1+ Mac, or discrete GPU on Windows/Linux).',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/zh.js